import { render, staticRenderFns } from "./ManageShares.vue?vue&type=template&id=14e1b256&scoped=true&"
import script from "./ManageShares.vue?vue&type=script&lang=js&"
export * from "./ManageShares.vue?vue&type=script&lang=js&"
import style0 from "./ManageShares.vue?vue&type=style&index=0&id=14e1b256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e1b256",
  null
  
)

export default component.exports